import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import './TallyShowcase.css';
import { Fade } from 'react-reveal';
import { FaBriefcase, FaServer, FaCloud, FaWhatsapp, FaWrench, FaMobile } from 'react-icons/fa';

const TallyShowcase = () => {
  const navigate = useNavigate(); // Initialize navigate

  const handleClick = (product) => {
    if (product === 'TallySoftware') {
      navigate('/TallySoftware'); // Use navigate instead of history.push
    }
    if (product === 'TallyPrimeServer') {
      navigate('/TallyPrimeServer'); // Use navigate instead of history.push
    }
    if (product === 'TallyAws') {
      navigate('/TallyAws'); // Use navigate instead of history.push
    }
    if (product === 'WhatsAppBusiness') {
      navigate('/WhatsAppBusiness'); // Use navigate instead of history.push
    }
    if (product === 'TallyPlatform') {
      navigate('/TallyPlatform'); // Use navigate instead of history.push
    }
    if (product === 'TallyDefinition') {
      navigate('/TallyDefinition'); // Use navigate instead of history.push
    }
    if (product === 'PrimeDetails') {
      navigate('/PrimeDetails'); // Use navigate instead of history.push
    }
    if (product === 'TallyDetails') {
      navigate('/TallyDetails'); // Use navigate instead of history.push
    }
    if (product === 'BizAnalyst') {
      navigate('/BizAnalyst'); // Use navigate instead of history.push
    }
    if (product === 'OurService') {
      navigate('/OurService'); // Use navigate instead of history.push
    }
    if (product === 'TallyIra') {
      navigate('/TallyIra');
    }
  };

  const [expandedProduct, setExpandedProduct] = useState(null);

  const toggleDescription = (product) => {
    setExpandedProduct(expandedProduct === product ? null : product);
  };

  return (
    <div className="tallyshow-container">
      <h1 className="title">TallyPrime Products & Custom Solutions</h1>
      
      <div className="tallyshow-sections">
        
        {/* ── Our Products ── */}
        <section className="tallyshow-section">
          <h2>Our Products</h2>
          <div className="product-list">
            
            <div className="product-item" onClick={() => handleClick('PrimeDetails')}>
              <img src="/images/tally-prime-3d-bg-removed.png" alt="TallyPrime" className="product-image tally-3d-asset" />
              <h3>TallyPrime</h3>
              <p>Fast and Powerful Business Management Software for your growing business.</p>
              <span className="read-more">Learn More</span>
            </div>

            <div className="product-item" onClick={() => handleClick('TallySoftware')}>
              <img src="/images/logotally/product-tss.png" alt="Tally Software Services" className="product-image" />
              <h3>Tally Software Services</h3>
              <p>A collection of connected services for TallyPrime to keep your business updated.</p>
              <span className="read-more">Learn More</span>
            </div>

            <div className="product-item" onClick={() => handleClick('TallyPrimeServer')}>
              <img src="/images/logotally/tallyprime-server-software-250x250.webp" alt="TallyPrime Server" className="product-image" />
              <h3>TallyPrime Server</h3>
              <p>An enterprise-class product to significantly improve your business efficiencies.</p>
              <span className="read-more">Learn More</span>
            </div>

            <div className="product-item" onClick={() => handleClick('OurService')}>
              <img src="/images/logotally/tallyprime-on-cloud.png" alt="iMatrix Services" className="product-image" />
              <h3>Comprehensive Services</h3>
              <ul>
                <li>AMC Sync & Support</li>
                <li>Direct On-site Visits</li>
                <li>Remote Technical Help</li>
                <li>Corporate Training</li>
                <li>Implementation & Consultation</li>
              </ul>
              <span className="read-more">View Services</span>
            </div>

            <div className="product-item" onClick={() => handleClick('TallyAws')}>
              <img src="/images/logotally/04.png" alt="TallyPrime AWS" className="product-image" />
              <h3>TallyPrime on AWS</h3>
              <p>Access your TallyPrime license and data virtually from anywhere with AWS cloud.</p>
              <span className="read-more">Learn More</span>
            </div>

            <div className="product-item" onClick={() => handleClick('WhatsAppBusiness')}>
              <img src="/images/logotally/whatsapp-directly-from-tally.jpg" alt="Tally with WhatsApp" className="product-image" />
              <h3>TallyPrime with WhatsApp</h3>
              <p>Share invoices, reports, and documents instantly via WhatsApp directly from Tally.</p>
              <span className="read-more">Learn More</span>
            </div>

            <div className="product-item" onClick={() => handleClick('BizAnalyst')}>
              <img src="/images/logotally/unnamed.png" alt="Tally Business Analyst" className="product-image" />
              <h3>Biz Analyst (Mobile)</h3>
              <p>Securely sync with TallyPrime to access your business data anytime, even when offline.</p>
              <span className="read-more">Learn More</span>
            </div>

            <div className="product-item" onClick={() => handleClick('TallyIra')}>
              <img src="/images/tally/Blog_Effortless-e-Invoicing-with-TallyPrimes-e-Tims-solution-2.jpg" alt="TallyIra AI Assistant" className="product-image" style={{objectFit: 'cover'}} />
              <h3>TallyIra (AI Assistant)</h3>
              <p>Automate document entry, auto-generate draft vouchers, and fetch instant reports anywhere.</p>
              <span className="read-more">Learn More</span>
            </div>
          </div>
        </section>

        {/* ── Custom Solutions ── */}
        <section className="tallyshow-section">
          <h2>Custom Solutions & Integrations</h2>
          <div className="solution-list">
            <div className="solution-item" onClick={() => handleClick('TallyPlatform')}>
              <img src="/images/tally/black-woman-working-office-communication-600nw-2312841739.webp" alt="Custom Tally Solutions" className="solution-image" />
              <h3>Extensions & Customizations</h3>
              <p>Extend and customize Tally to fulfill specific business needs and boost operational efficiency.</p>
              <span className="read-more">Learn More</span>
            </div>

            <div className="solution-item" onClick={() => handleClick('TallyDefinition')}>
              <img src="/images/tally/TDL-1.jpg" alt="Tally Development" className="solution-image" />
              <h3>TallyPrime Developer</h3>
              <p>Develop and deploy specialized solutions for TallyPrime with our comprehensive development suite.</p>
              <span className="read-more">Learn More</span>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default TallyShowcase;
